<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    icon?: string
    label?: string
    severity?: string
  }>(),
  {
    severity: 'primary',
    label: 'Enviar',
  }
)
</script>

<template>
  <Button fluid type="submit" v-bind="props" />
</template>
